// tslint:disable: object-literal-sort-keys
export enum AppEventType {
  GraphqlError = 'grphql:error',
  AuthError = 'auth:error',
  NetworkError = 'network:error',
}

// eslint-disable-next-line no-undef
export const dispatchAppEvent = (type: AppEventType, initDict?: CustomEventInit): boolean =>
  dispatchEvent(new CustomEvent(type, initDict));
